module.exports = __webpack_public_path__ + "img/plate-of-rice-and-cooked-meat-1624487.b058fb36.jpg";